export default "__VITE_ASSET__DOnhYBbZ__"